function normalizeApiBaseUrl(rawBaseUrl: string | undefined): string {
  const fallback = 'http://localhost:8000/api/v1';
  const candidate = rawBaseUrl?.trim() || fallback;

  try {
    const url = new URL(candidate);
    url.pathname = url.pathname === '/' ? '/api/v1' : url.pathname.replace(/\/$/, '');
    return url.toString().replace(/\/$/, '');
  } catch {
    return fallback;
  }
}

const apiBaseUrl = normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL);

export interface ServiceRequestPayload {
  request_type: 'service' | 'consultation';
  source: 'web' | 'telegram';
  page_slug?: string | null;
  page_title: string;
  full_name: string;
  phone: string;
  email: string;
  request_text?: string | null;
  meta?: Record<string, unknown>;
}

export interface ServiceRequestResponse {
  request_id: string;
  status: string;
}

interface ApiValidationError {
  detail?: unknown;
}

function formatValidationDetail(detail: unknown): string | null {
  if (typeof detail === 'string' && detail.trim().length > 0) return detail;
  if (!Array.isArray(detail)) return null;

  const messages = detail
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null;
      const message = (entry as { msg?: unknown }).msg;
      return typeof message === 'string' && message.trim().length > 0 ? message : null;
    })
    .filter((message): message is string => Boolean(message));

  return messages.length ? messages.join('; ') : null;
}

export async function submitServiceRequest(payload: ServiceRequestPayload): Promise<ServiceRequestResponse> {
  const response = await fetch(`${apiBaseUrl}/service-requests`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data = (await response.json().catch(() => null)) as ApiValidationError | ServiceRequestResponse | null;
  if (!response.ok) {
    throw new Error(formatValidationDetail((data as ApiValidationError | null)?.detail) || 'Не удалось отправить заявку');
  }

  return data as ServiceRequestResponse;
}
